import { render, staticRenderFns } from "./TipoVehiculoModalNuevo.vue?vue&type=template&id=3c63f6b2&scoped=true&"
import script from "./TipoVehiculoModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoVehiculoModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoVehiculoModalNuevo.vue?vue&type=style&index=0&id=3c63f6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63f6b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3c63f6b2', component.options)
    } else {
      api.reload('3c63f6b2', component.options)
    }
    module.hot.accept("./TipoVehiculoModalNuevo.vue?vue&type=template&id=3c63f6b2&scoped=true&", function () {
      api.rerender('3c63f6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipoVehiculoModalNuevo.vue"
export default component.exports